import React, { FC, InputHTMLAttributes } from 'react';
import styled, { css } from 'styled-components/macro';
import { Switch } from 'visits-style';
import theme from 'styles/theme';
import media from 'styles/media';

const Wrapper = styled.div<{ disabled: boolean; labelMargin?: string }>`
  display: flex;
  flex-direction: row;
  align-items: center;

  > label {
    color: ${({ disabled }) =>
      disabled ? theme.textSecondary : theme.labelDefault};
    font-size: 16px;
    font-weight: bold;
    line-height: 1.5;
    ${({ labelMargin }) =>
      labelMargin
        ? css`
            margin-right: ${labelMargin};
          `
        : css`
            margin-right: 20px;
          `}

    ${media.mobile} {
      margin-right: 16px;
      font-size: 14px;
    }
  }

  > span {
    ${({ disabled }) =>
      disabled &&
      css`
        cursor: default;
      `}
  }

  > span > label {
    min-width: 44px;
    height: 24px;
    border-width: 0;
    border-radius: 12px;
    background: ${theme.bgSwitchOff};
    box-shadow: none !important;

    ::after {
      top: 2px;
      left: 2px;
      width: 20px;
      height: 20px;
      border-width: 0;
      box-shadow: none;
    }

    ${({ disabled }) =>
      disabled &&
      css`
        pointer-events: none;
        cursor: default;
      `}
  }

  input:checked ~ label {
    background: ${({ disabled }) =>
      disabled ? theme.bgSwitchOff : theme.bgSwitchOn};

    ::after {
      left: calc(100% - 22px);
    }
  }
`;

type SwitchProps = InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  labelMargin?: string;
  disabled?: boolean;
};

const StyledSwitch: FC<SwitchProps> = props => {
  const { label, disabled = false, labelMargin, ...attrs } = props;
  return (
    <Wrapper disabled={disabled} labelMargin={labelMargin}>
      {label && <label>{label}</label>}
      <Switch {...attrs} disabled={disabled} />
    </Wrapper>
  );
};

export default StyledSwitch;
